module.exports = __webpack_public_path__ + "img/spay_tech.page.44ed2e76.png";